import { Injectable } from '@angular/core';

import { ICountry, LookupsService } from 'common';

@Injectable()
export class CountryResolver  {
  constructor(private lookupsService: LookupsService) { }

  resolve() {
    return this.lookupsService.getCountries().toPromise();
  }
}
